<ng-container *ngIf="confirmDialog.state$ | async as state">
  <div class="confirm-overlay">
    <div class="confirm-dialog">
      <div class="confirm-header">
        <div
          class="confirm-icon"
          [class.confirm-icon-danger]="state.danger">
          !
        </div>

        <div>
          <div class="confirm-title">{{ state.title }}</div>
          <div class="confirm-message">{{ state.message }}</div>
        </div>
      </div>

      <div class="confirm-actions">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="cancel()">
          {{ state.cancelText || 'Cancel' }}
        </button>

        <button
          type="button"
          class="btn"
          [class.btn-danger]="state.danger"
          [class.btn-primary]="!state.danger"
          (click)="confirm()">
          {{ state.confirmText || 'Confirm' }}
        </button>
      </div>
    </div>
  </div>
</ng-container>